import React from "react";
import { CellWrapper, CellValue, CellEmpty, DraftValue } from "./Cell.styled";

/**
 * Generic table cell that displays a value or an empty placeholder.
 *
 * @param {number}  width        — fixed column width in px
 * @param {string}  [value]      — formatted display value
 * @param {string}  [emptyLabel] — placeholder for null/undefined value (default "—")
 * @param {string}  [variant]    — "draft" for draft-styled value
 * @param {string}  [title]      — tooltip text
 * @param {React.ReactNode} [children] — custom content (overrides value rendering)
 */
const DataCell = ({
  width = 120,
  value,
  emptyLabel = "—",
  variant,
  title,
  children,
}) => (
  <CellWrapper $width={width}>
    {children ? (
      children
    ) : value ? (
      variant === "draft" ? (
        <DraftValue title={title}>{value}</DraftValue>
      ) : (
        <CellValue>{value}</CellValue>
      )
    ) : (
      <CellEmpty>{emptyLabel}</CellEmpty>
    )}
  </CellWrapper>
);

export default DataCell;
